import React from 'react';
import { ArrowRight, BookOpen, Users, Award } from 'lucide-react';

const HeroSection = () => {
  const scrollToPlans = () => {
    const element = document.getElementById('plans');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center pt-28 pb-16 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-100 via-sky-50 to-indigo-100 opacity-50"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(191,219,254,0.3),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(224,242,254,0.3),transparent_50%)]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
           <h1 className=" pt-8 text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-blue-600 leading-tight">
              Quiet Corners for{' '}
              <span className=" relative inline-block">
                Big Dreams
              
              </span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Experience focused learning in a peaceful, distraction-free environment designed for 
              students and professionals. Your success story starts here.
            </p>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 py-4">
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 p-3 rounded-xl">
                  <BookOpen className="text-blue-700" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">13 Hours</p>
                  <p className="text-sm text-gray-600">Daily Access</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-sky-100 p-3 rounded-xl">
                  <Users className="text-sky-700" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">40+</p>
                  <p className="text-sm text-gray-600">Private Desks</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-indigo-100 p-3 rounded-xl">
                  <Award className="text-indigo-700" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">100%</p>
                  <p className="text-sm text-gray-600">Silent Zone</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToPlans}
                className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 group"
              >
                View Membership Plans
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={scrollToContact}
                className="bg-white text-blue-700 px-8 py-4 rounded-full font-semibold border-2 border-blue-600 hover:bg-blue-50 transition-all duration-300 hover:scale-105"
              >
                Book a Visit
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-transform duration-500 aspect-4/3">
              <img
                src="/assets/AdhyanPhotos11.jpg"
                alt="Study Space"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
           
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-3 bg-white p-6 rounded-2xl shadow-xl max-w-xs">
              <h6 className="text-lg text-gray-600  font-semibold "> Flexible Membership</h6>
              
              <h6 className="text-lg text-gray-600 mt-1 font-semibold">Plans Available</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
